import moment from 'moment'

const DEFAULT_DATE_FORMAT = 'L'
const DEFAULT_DATETIME_FORMAT = 'L LT'

const ISO_DATE_FORMAT = 'YYYY-MM-DD'

const helpers = {
  checkInvalid (res) {
    // Return a blank string instead of 'Invalid date'
    return res === 'Invalid date' ? '' : res
  }
}

export default {
  dateFormat (dateStr) {
    // Edgecase
    if (dateStr === '0000-00-00') {
      return '01/01/1990'
    }
    // Format as the app default date format
    let res = moment(dateStr).format(DEFAULT_DATE_FORMAT)
    return helpers.checkInvalid(res)
  },
  datetimeFormat (datetimeStr) {
    // Format as the app default datetime format
    let res = moment(datetimeStr).format(DEFAULT_DATETIME_FORMAT)
    return helpers.checkInvalid(res)
  },
  unixFormat (unixTime) {
    let res = moment.unix(unixTime).format(DEFAULT_DATE_FORMAT)
    return helpers.checkInvalid(res)
  },
  unixDatetimeFormat (unixTime) {
    let res = moment.unix(unixTime).format(DEFAULT_DATETIME_FORMAT)
    return helpers.checkInvalid(res)
  },
  isoFormat (date) {
    // Returns ISO formatted with only day, month, and year
    return moment(date).format(ISO_DATE_FORMAT)
  },
  isoDatetimeFormat (datetime) {
    // Will return ISO formatted with hours, minutes, and seconds
    return moment(datetime).format()
  },
  isDateOfFormat (date, format) {
    return moment(date, format, true).isValid()
  },
  today() {
    return moment()
  },
  tomorrow()
  {
    return moment().add(1,'days')
  },
  yesterday() {
    return moment().add(-1, 'days')
  },
  iso_date_to_card_exp(date_str, num_digits) {
    let arr = date_str.split('T')[0].split('-')
    return `${arr[1]}/${arr[0].slice(4 - num_digits,4)}`
  },
  isoDateStringToReadable(date_str) {
    let components = date_str.split('-');
    let date = new Date(components[0], components[1] - 1, components[2]);
    let options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Intl.DateTimeFormat('en-US', options).format(date);
  }
}



// WEBPACK FOOTER //
// ./src/lib/dates.js